import { inject } from "mobx-react";
import { Fragment } from "react";
import { ResponsiveImage } from "../../../../core/components/ResponsiveImage.component";
import { makeAd, ABV_HEADER_IMAGE, RESPONSIVE_IMAGE } from "@inferno/renderer-shared-core";
import { AdPosition } from "../../../../core/page-blocks/Ad.component";
import { Heading, MagicLink } from "../../../../core/ui";
import { CoastArchiveFeedShowsProps, CoastFeedItemType, getCoastFeedImg } from "../../lib/coastFeed";
import { CoastFeedNavigation } from "./coast-feed-navigation/CoastFeedNavigation.component";
import { CoastFeedAds } from "./CoastFeedAds.component";
import { CoastFeedNoResults } from "./CoastFeedNoResults.component";
import { CoastFeedShowItem } from "./CoastFeedShowItem.component";

export const CoastFeedArtBellVaultShows = inject("store")(
  ({ block, store, content, title }: CoastArchiveFeedShowsProps) => {
    if (!store) {
      return null;
    }

    const { imgSrc, srcset } = getCoastFeedImg(ABV_HEADER_IMAGE, CoastFeedItemType.ART_BELL_VAULT, { quality: 80 });

    return (
      <Fragment>
        <Heading level={2}>{title}</Heading>

        <section className="coast-feed-header">
          <div className="coast-feed-item">
            <figure className="item-thumb">
              <ResponsiveImage
                alt="Art Bell Vault"
                src={imgSrc}
                srcset={srcset}
                initialWidth={RESPONSIVE_IMAGE.responsiveImageInitialWidth}
                initialHeight={RESPONSIVE_IMAGE.responsiveImageInitialHeight}
              />
            </figure>

            <section className="item-summary">
              <Heading level={2}>Welcome to Art Bell Vault!</Heading>
              <p>
                Coast Insiders - enjoy our selection of vintage, commercial-free Art Bell shows, available for
                streaming-on-demand for both mobile and desktop platforms. Two new programs added to the Vault each
                week!
              </p>

              {!store.session.currentSession?.authenticated ? (
                <>
                  Not yet a Coast Insider?&nbsp;
                  <MagicLink className="sign-up" to="/sign-up/">
                    Get Access
                  </MagicLink>
                </>
              ) : null}
            </section>
          </div>

          <AdPosition block={makeAd("3308", 0)} batchId="first-item" />
        </section>
        <CoastFeedNavigation displayHostCategories={false} displayDateSelect={false} />
        {content?.length ? (
          <div className="feed-cards">
            {content.map((item, itemIdx) => (
              <Fragment key={item.id}>
                <CoastFeedShowItem item={item} type={CoastFeedItemType.ART_BELL_VAULT} />
                <CoastFeedAds
                  blockSize={block.value.size}
                  itemCount={content.length}
                  blockId={block.id}
                  itemIdx={itemIdx}
                />
              </Fragment>
            ))}
          </div>
        ) : (
          <CoastFeedNoResults />
        )}
      </Fragment>
    );
  },
);

export default CoastFeedArtBellVaultShows;
